import { render, staticRenderFns } from "./AffiliatesLegalTos.vue?vue&type=template&id=53309fb8&"
import script from "./AffiliatesLegalTos.vue?vue&type=script&lang=js&"
export * from "./AffiliatesLegalTos.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesLegalTos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53309fb8')) {
      api.createRecord('53309fb8', component.options)
    } else {
      api.reload('53309fb8', component.options)
    }
    module.hot.accept("./AffiliatesLegalTos.vue?vue&type=template&id=53309fb8&", function () {
      api.rerender('53309fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesLegalTos.vue"
export default component.exports